import { useState } from "react"
import { fetchLabwareList } from "../../../../pages/ExperimentPlanner/api"

export const ObjectSelector = ({
  id,
  onChange,
  selectedObject
}) => {
  const [objectsList, setObjectsList] = useState([])
  const [isFetching, setIsFetching] = useState(false)

  const handleGetObjects = e => {
    setIsFetching(true)
    fetchLabwareList().then((data) => {
      console.log(data)
      setObjectsList(data);
    }).finally(() => {
      setIsFetching(false)
    });
  }

  const handleSelectObject = (e) => {
    onChange(id, e.target.value)
  }

  const handleDeLink = e => {
    setObjectsList([])
    onChange(id, null)
  }

  if (!selectedObject) {
    return (<div>
      {objectsList.length === 0 && !isFetching && <button onClick={handleGetObjects}>Get Objects</button>}
      {objectsList.length === 0 && isFetching && <span>Fetching...</span>}
      {objectsList.length > 0 && !isFetching &&
        <select onChange={handleSelectObject}>
          <option key={null} value={null}>-</option>
          {objectsList.map((obj, idx) => {
            return <option key={obj._id} value={obj._id}>{obj.Label}</option>
          })}
        </select>
      }
    </div>)
  }

  return (
    <div>
      {selectedObject.id} <button onClick={handleDeLink}>De-link</button>
    </div>
  )
}
